import React from 'react'

import { Carousel } from '@tecsinapse/cortex-react'
import { t } from '@lingui/core/macro'

interface HomeSlideDefaultCortexProps {
  linkHelptec: string
}

export const HomeSlideDefault = ({
  linkHelptec
}: HomeSlideDefaultCortexProps) => {
  return (
    <Carousel
      images={[
        {
          src: 'bg-banner-1.jpg',
          title: {
            text: t`SEJA BEM-VINDO AO NOVO PORTAL`,
            color: 'white',
            size: '35px'
          },
          alt: 'slide-default',
          subtitle: {
            text: t`Com novos recursos e design mais atrativo e fácil de usar. Aproveite as novidades! Dúvidas? Acesse a Central de Relacionamentos, HelpTec.`,
            color: 'white',
            size: '14px'
          },
          button: {
            title: t`ACESSAR HELPTEC`,
            link: linkHelptec,
            target: '_blank'
          }
        }
      ]}
    />
  )
}
